import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-authorize-error-dialog',
  templateUrl: './authorize-error-dialog.component.html',
  styleUrls: ['./authorize-error-dialog.component.css']
})
export class AuthorizeErrorDialogComponent implements OnInit {

  constructor(
    private readonly authService: AuthService,
    private dialogRef: MatDialogRef<AuthorizeErrorDialogComponent>
  ) { }

  ngOnInit() {
  }


  logout() {
    this.authService.logout();

  }

}
